import { Scripts } from "@/commonJS/Actions/actionInterface";

export const renderScript = (parameters: Scripts, index: string) => {
  if (typeof document !== "undefined") {
    const delay = parameters.delay || 0;

    setTimeout(() => {
      const script = document.createElement("script");
      script.src = parameters.src;
      script.async = parameters.async ?? true;
      script.defer = parameters.defer ?? true;
      script.id = `script-${index}`;

      Object.keys(parameters).forEach((key) => {
        if (!["src", "async", "defer", "delay"].includes(key)) {
          // @ts-ignore
          script.setAttribute(key, parameters[key]);
        }
      });

      document.head.appendChild(script);
    }, delay);
  }
};
